import * as React from "react";
import Drawer from "material-ui/Drawer";
import { observer } from "mobx-react";
import { action } from "mobx";
import { hashHistory } from "react-router";
import SeekerStore from "../../../stores/seekerStore";
import { ILocalization } from "../../../models/localization";
import { Auth } from "../../../utils/auth";
import List, { ListItem, ListItemText } from "material-ui/List";
import LoginDlg from "../../dialogs/login";
import RegistrationDlg from "../../dialogs/registration";
import IconButton from "material-ui/IconButton";
import ArrowButton from "material-ui-icons/ArrowBack";
import BottomNavigation, { BottomNavigationAction } from 'material-ui/BottomNavigation';
import RestoreIcon from 'material-ui-icons/Restore';
import FavoriteIcon from 'material-ui-icons/Favorite';
import LocationOnIcon from 'material-ui-icons/LocationOn';
import { ScreenMode } from "../../../models/enums";

const listStyle: any = { width: "45vw", paddingLeft: "15vw" };
const style = { MuiIconButton: { color: "#5B6770" } };

@observer
export default class SideBar extends React.Component<{ store: SeekerStore }, {}> {
  constructor(props: any) {
    super(props);
  }

  toggleDrawer = (side: string, open: boolean) => () => {
    this.setState({
      [side]: open,
    });
  };

  logoff = (): void => {
    this.props.store.viewState.closeDrawer();   
    Auth.logout(this.props.store.viewState.clearData);
  }

  openHelpVw = (): void => {
    hashHistory.push("/help");
    this.props.store.viewState.closeDrawer();
  }

  openGettingStartedVw = (): void => {
    hashHistory.push("/gettingStarted");
    this.props.store.viewState.closeDrawer();
  }

  renderSidebar(): JSX.Element[] {
  let local: ILocalization = this.props.store.localization.fields;
  let items: JSX.Element[] = [];

  if (Auth.isAuthenticated) {
    items.push(<div key="side-bar-auth">
      <ListItem key={local.sideNav.quickStart} onClick={() => this.openGettingStartedVw()} >
      <ListItemText primary={local.sideNav.quickStart} />
      </ListItem>
      <ListItem key={local.sideNav.help} onClick={() => this.openHelpVw()} >
       <ListItemText primary={local.sideNav.help} />
     </ListItem>
     <ListItem key="lang" onClick={() => this.props.store.viewState.setShowLanguages(true)} >
       <ListItemText primary="Lang" />
     </ListItem>
     <ListItem key={local.sideNav.logout} onClick={() => this.logoff()} >
       <ListItemText primary={local.sideNav.logout} />
     </ListItem>
   </div>)
  } else {
    items.push(<div key="side-bar-anon">
      <ListItem key="login" onClick={() => this.props.store.viewState.setShowLogin(true)} >
        <ListItemText primary={local.login.login} />
      </ListItem>
      <ListItem key="register" onClick={() => this.props.store.viewState.setShowRegister(true)} >
        <ListItemText primary={local.login.register} />
      </ListItem>
      <ListItem key="help" onClick={() => this.openHelpVw()}>
        <ListItemText primary={local.sideNav.help} />
      </ListItem>
      <ListItem key="lang" onClick={() => this.props.store.viewState.setShowLanguages(true)} >
        <ListItemText primary="Lang" />
      </ListItem>
    </div>)
  }
  return items;
  }

  render(): JSX.Element {
    const mode: ScreenMode = this.props.store.viewState.screenMode;
    let localization: ILocalization = this.props.store.localization.fields;

    return <div>
      <Drawer anchor="left" open={this.props.store.viewState.showDrawer} onClose={() => this.toggleDrawer('left', false)} >
        <List style={listStyle}>
          <ListItem key="close" onClick={() => this.props.store.viewState.toggleDrawer()} >
            <IconButton style={style.MuiIconButton} aria-label="arrow-foward"><ArrowButton />
            </IconButton>
          </ListItem>
          {this.renderSidebar()}
        </List>
      </Drawer>
    </div>
  }
}


// WEBPACK FOOTER //
// ./src/components/app/sidebar/index.tsx